// Graph 读取 API 封装 / Graph read API facade.
// 后端按 sim_id 合并返回 graph/nodes.json + edges.json + meta.json（properties 已解析）。
// Backend merges the three graph artifacts per sim_id with parsed properties.
import { api } from "@/api/client";

// 图节点行 / One graph node row.
export interface GraphNodeRow {
  node_id: string;
  node_type: "persona" | "kol" | "product" | "expert";
  label: string;
  properties: Record<string, unknown>;
  sim_id: string;
  arm: string;
}

// 图边行 / One graph edge row.
export interface GraphEdgeRow {
  edge_id: string;
  src_id: string;
  dst_id: string;
  edge_type: "influence" | "adopt" | "score";
  weight: number | null;
  wave: number | null;
  properties: Record<string, unknown>;
  sim_id: string;
  arm: string;
}

// simulation 级图元数据 / Simulation-level graph metadata.
export interface GraphMeta {
  sim_id?: string;
  arms?: string[];
  skill?: string;
  total_waves?: number;
  wave_time_window_hours?: number;
  status?: string;
  context?: Record<string, unknown>;
  context_by_arm?: Record<string, unknown>;
}

// Graph 读取响应 / Graph read response envelope.
export interface GraphResponse {
  ok: true;
  sim_id: string;
  nodes: GraphNodeRow[];
  edges: GraphEdgeRow[];
  meta: GraphMeta;
}

export const graphApi = {
  get: (simId: string) =>
    api.get<GraphResponse>(`/api/v1/simulations/${encodeURIComponent(simId)}/graph`),
};
